import React from 'react';
import SummarySectionDisplay from './SummarySectionDisplay';
import SummaryListDisplay from './SummaryListDisplay';
import SummaryMapDisplay from './SummaryMapDisplay';
//import BMPLocationDisplay from '../BMPLocationDisplay';
import LoggedBMPDisplay from '../LoggedBMPDisplay';
import _ from 'lodash';
import { Link } from 'react-router-dom'

import {
  isMobileOnly
} from 'react-device-detect'


export default function InspectionSummaryDisplay({handleBMPChange, reportState, handleChange, headerChild, footerChild, captureMapNow, getMapImageCallback}){

	let {workUnit, flexdata, status, canEditFlexdata, idsite} = reportState;
	let phaseHistory = Array.isArray(flexdata.phaseHistory) ? flexdata.phaseHistory : [];
	let verifiedBMPList = Array.isArray(flexdata.verifiedBMPList) ? flexdata.verifiedBMPList : [];
	let unaddressedBMPCount = _.filter(verifiedBMPList, (bmp) => !bmp.status).length;
	let hasUnaddressedBMPs = unaddressedBMPCount > 0;
	let hasVisitedBMPVerification = phaseHistory.indexOf("BMPVerification") !== -1;
	let hasLoggedBMPs = Array.isArray(reportState.loggedBMPs) && reportState.loggedBMPs.length > 0;
	let hasVerifiedBMPStatuses = _.some(verifiedBMPList, (bmp) => typeof bmp.status === "string" && bmp.status.length > 0);
	let showBMPVerificationWarning = hasUnaddressedBMPs && (hasVisitedBMPVerification || hasLoggedBMPs);
	let showBMPCategoryEmptyState = hasLoggedBMPs || hasVerifiedBMPStatuses;
	let bmpCorrectiveActionLabel = "BMPs that need corrective action are shown under 'Logged BMPs'.";
	let unaddressedBMPMessage = unaddressedBMPCount === 1 ?
		"1 BMP still needs a status assignment before summary categories are complete." :
		unaddressedBMPCount + " BMPs still need status assignments before summary categories are complete.";
	let formatInspectionType = (inspectionType) => {
		if (typeof inspectionType !== "string" || inspectionType.length === 0) return inspectionType;
		if (inspectionType === "weekly") return "Weekly";
		if (inspectionType === "precipitation") return "Precipitation Event";
		return inspectionType.charAt(0).toUpperCase() + inspectionType.slice(1);
	};

	return(<>
		<header className="section-header mb-0">
			<h2><strong>Inspection Summary</strong></h2>
		</header>

		<div className="section pt-4">
			<div className="container px-0">

				{headerChild ? headerChild() : null}

				<div className="row">

					<div class="text-left float-left border-bottom pb-5 mb-5 col-12">
						<Link class="btn btn-sm btn-secondary" to={() => '/app/inspection-reports'}><i class="fa fa-angle-left mr-1"></i>Inspection Reports</Link>
					</div>

					{(!idsite && status === "setup") ? (isMobileOnly ? 
						<div class="col-12 border-bottom pb-5">
              <p class="lead-3 p-0 mb-4 ml-2 pl-2">{workUnit.name}</p>
              <button class="btn btn-block btn-primary" onClick={() => handleChange("phase", "ProjectInfo")}>Start Inspection</button>
	          </div>
					:
						<div className="col-12 border-bottom pb-5 flexbox">
							<p className="lead-3 p-0 mb-0 ml-2 pl-2">{workUnit.name}</p>
							<button class="btn btn-primary" onClick={() => handleChange("phase", "ProjectInfo")}>Start Inspection</button>
						</div>
          ) : null}

					<div className="col-12 mx-auto mb-6 clearfix px-0">

						<SummarySectionDisplay
							title="Site Info"
							sectionPhase="ProjectInfo"
							phaseHistory={phaseHistory}
							items={[
								{label: "Construction Site Name", value: (reportState.name || reportState.siteName || reportState.sitename)},
								{label: "Site ID #", value: flexdata.officialsiteid},
								{label: "Location, Municipality, County", value: flexdata.municipality, detectCapitalizationIssues: true},
								{label: "Contractor/Onsite Contact", value: flexdata.onsitecontact},
							]}
							showEdit={canEditFlexdata}
							edit={() => handleChange("phase", "ProjectInfo")}
							status={status}
							isMobileOnly={isMobileOnly}
						/>

						<SummarySectionDisplay
							title="Inspection Info"
							sectionPhase="InspectionInfo"
							phaseHistory={phaseHistory}
							items={[
								{label: "Inspection Date", value: reportState.date, type: "date"},
								{label: "Inspection Type", value: formatInspectionType(reportState.type)},
								{label: "Start Time", value: reportState.date, type: "time"},
								{label: "End Time", value: flexdata.inspectionend, type: "time", emptyStateOverride: "Automatically set during wrap-up."},
								{label: "Name(s) of Inspectors", value: flexdata.inspectionnames},
								{label: "Inspector Phone #", value: flexdata.inspectorphone, type: "phone"},
							]}
							showEdit={canEditFlexdata}
							edit={() => handleChange("phase", "InspectionInfo")}
							status={status}
							isMobileOnly={isMobileOnly}
						/>

						<SummarySectionDisplay
							title="Weather Conditions"
							sectionPhase="WeatherAndSoil"
							phaseHistory={phaseHistory}
							items={[
								{label: "Temperature", value: flexdata.temperature},
								{label: "Soil Moisture", value: flexdata.soilmoisture, type: "checkbox"},
								{label: "Last Rainfull Date", value: flexdata.lastrainfalldate, type: "datetime"},
								{label: "Last Rainfall Depth", value: flexdata.lastrainfalldepth}
							]}
							showEdit={canEditFlexdata}
							edit={() => handleChange("phase", "WeatherAndSoil")}
							status={status}
							isMobileOnly={isMobileOnly}
						/>

						<SummarySectionDisplay
							title="Project Phase"
							sectionPhase="ProjectPhase"
							phaseHistory={phaseHistory}
							items={[
								{label: "Phase of Construction", value: flexdata.currentphase},
								{label: "Report Based on Plan/Sheets:", value: flexdata.basedonsheets},
								{label: "Plan Sheets Dated", value: flexdata.sheetdate, type: "date"},
							]}
							showEdit={canEditFlexdata}
							edit={() => handleChange("phase", "ProjectPhase")}
							status={status}
							isMobileOnly={isMobileOnly}
						/>						

					</div>

				</div>



				<div className="row">

					<SummaryMapDisplay
						reportState={reportState}
						captureMapNow={captureMapNow}
						getMapImageCallback={getMapImageCallback}
						handleChange={handleChange}
					 />

					{/*<div className="col-12 clearfix my-2 border-bottom mb-6">
						<div className="col-4 flexbox float-right">
							<label className="small strong text-brand">FILTER</label>
							<label className="lead-4 strong text-success"><i className="fa fa-check-square mr-2 text-success"></i></label>
							<label className="lead-4 strong text-warning"><i className="fa fa-exclamation-triangle mr-2 text-warning"></i></label>
							<label className="lead-4 strong text-danger"><i className="fa fa-clock-o mr-2 text-danger"></i></label>
						</div>
					</div>*/}

					<div className="col-12 mx-auto p-0 m-0 my-lg-4 pb-4 mb-4 pt-lg-4 pb-lg-7">


					{reportState.loggedBMPs.length ? reportState.loggedBMPs.map((bmp, index) => {
						return <LoggedBMPDisplay
							passedBMP={bmp}
							key={bmp.idaction}
							handleChange={handleChange}
							handleBMPChange={handleBMPChange}
							reportState={reportState}
							isMobileOnly={isMobileOnly}
						/>
					}) : <span className="text-small text-light ml-6">No BMPs logged yet</span>}

					</div>
				</div>

				{showBMPVerificationWarning ?
					<div className="col-12 px-0 float-left mb-3">
						<div className={"alert position-static mt-2 mb-0 " + (canEditFlexdata ? "alert-warning" : "alert-light border")} role="alert">
							<p className={"mb-1 strong " + (canEditFlexdata ? "text-warning" : "text-secondary")}>
								<i className={"fa " + (canEditFlexdata ? "fa-exclamation-triangle" : "fa-info-circle") + " mr-2"} aria-hidden="true"></i>
								BMP verification still needs attention
							</p>
							<p className="mb-0">{unaddressedBMPMessage}</p>
							{canEditFlexdata ?
								<button
									type="button"
									className="btn btn-xs btn-round btn-warning mt-3"
									onClick={() => handleChange("phase", "BMPVerification")}
								>
									Verify BMPs Now
								</button>
							: null}
						</div>
					</div>
				: null}

				{!isMobileOnly ?
					<div className="col-12 px-0 float-left mb-3">
						<label className="small ml-1 mb-0"><em>{bmpCorrectiveActionLabel}</em></label>
					</div>
				: null}

				<SummaryListDisplay
					title="BMPs in Good Condition"
					label={isMobileOnly ? bmpCorrectiveActionLabel : null}
					list={_.filter(verifiedBMPList, {status: "good"})}
					showEdit={canEditFlexdata}
					edit={() => handleChange("phase", "BMPVerification")}
					status={status}
					isMobileOnly={isMobileOnly}
					icon={"ti ti-check text-success"}
					showEmptyState={showBMPCategoryEmptyState}
					emptyStateTitle="No BMPs in this category"
					emptyStateMessage="No BMPs were marked in Good Condition for this inspection."
					emptyActionLabel="Verify BMPs Now"
				/>

				<SummaryListDisplay
					title="BMPs Currently Not Applicable"
					label={isMobileOnly ? bmpCorrectiveActionLabel : null}
					list={_.filter(verifiedBMPList, {status: "na"})}
					showEdit={canEditFlexdata}
					edit={() => handleChange("phase", "BMPVerification")}
					status={status}
					isMobileOnly={isMobileOnly}
					icon={"ti ti-na text-secondary"}
					showEmptyState={showBMPCategoryEmptyState}
					emptyStateTitle="No BMPs in this category"
					emptyStateMessage="No BMPs were marked as Not Applicable for this inspection."
					emptyActionLabel="Verify BMPs Now"
				/>

				<SummaryListDisplay
					title="Maintenance Crew for Corrective Actions"
					label="Text messages will be sent to these employees."
					labelClassName="small lh-1 ml-6"
					list={_.filter(reportState.employeesList || [], {selected: true})}
					forceEmptyState={_.filter(reportState.employeesList || [], {selected: true}).length <= 1}
					showEdit={canEditFlexdata}
					edit={() => handleChange("phase", "InspectionWrapUp")}
					status={status}
					isMobileOnly={isMobileOnly}
					useColumns={true}
					emptyStateVariant="warning"
					emptyStateTitle={canEditFlexdata ? "Maintenance Crew Needed" : "Maintenance Crew"}
					emptyStateMessage={canEditFlexdata ?
						"Add more maintenance crew recipients for corrective action text alerts." :
						(_.filter(reportState.employeesList || [], {selected: true}).length === 0 ?
							"No maintenance crew recipients are currently listed for corrective action text alerts." :
							"Only one maintenance crew recipient is currently listed for corrective action text alerts.")
					}
					emptyActionLabel="Select Crew Now"
				/>


				{footerChild ? footerChild() : null}

			</div>

		</div>
	</>);
}